import React from "react";
import { Link } from "react-router-dom";
import { Modal } from "react-bootstrap";
import edit from "../../images/a-post.svg";
import event from "../../images/a-event.svg";
import deal from "../../images/a-Deals.svg";
import styled from "styled-components";

const HeaderText = styled.label`
  font-family: Inter;
  font-style: normal;
  font-weight: 600;
  font-size: 28px;
  line-height: 34px;
  display: flex;
  align-items: center;
  text-align: center;
  color: #161f3d;
  display: flex;
  justify-content: center;
  margin-top: 16px;
`;

const IconView = styled.div`
  background: #c3c3f5;
  border-radius: 12px;
  height: 29px;
  width: 29px;
  display: flex;
  justify-content: center;
  align-items: center;
  position: absolute;
  left: 27px;
`;

const Button = styled(Link)`
  background: #696ae7;
  font-family: Inter;
  font-style: normal;
  font-weight: 600;
  font-size: 16px;
  line-height: 19px;
  text-align: center;
  color: #ffffff;
  display: flex;
  align-items: center;
  height: 55px;
  padding: 0 27px;
  justify-content: center;
  position: relative;
  margin: 12px 0;

  &:hover {
    background-color: #37cfd6;
    color: #ffffff;
  }
`;

const AddPopup = (props) => {
  return (
    <Modal
      className="add-popup"
      {...props}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
    >
      <Modal.Header closeButton>
        <Modal.Title id="contained-modal-title-vcenter"></Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <HeaderText>Add</HeaderText>
        <Button to="/create-post">
          <IconView className="icon">
            <img src={edit} alt="pen" />
          </IconView>
          Add new post
        </Button>
        <Button to="/create-event">
          <IconView className="icon">
            <img src={event} alt="pen" />
          </IconView>
          Add new event
        </Button>
        <Button to="/createdeal">
          <IconView className="icon">
            <img src={deal} alt="pen" />
          </IconView>
          Add new deal
        </Button>
      </Modal.Body>
    </Modal>
  );
};
export default AddPopup;
